
  import { ScanforOutBound_GetOffModule } from "@/store/modules/store_scanforoutbound_getoff";
  import {Component, Vue, Prop, Watch} from "vue-property-decorator";
  import dayjs from "dayjs";
  import { get171Container,carContainerStatus ,getCQInfoByCode, unLoadNum ,debusOnly,getLatticeScheme} from "@/api/service";
  import { LogHelper } from "@/common/LogHelper";
  import {from} from "linq";
import { SystemConfigModule } from "@/store/modules/store_systemconfig";
  import {toRawType} from "vue/src/shared/util";
  import { ModeAddType } from '@/common/glboalconstant';
  import { BizUtil } from "@/utils/biz-util";

  @Component({
    name: "Form2",
  })
  export default class extends Vue {
    @Prop() private form: OnCodeGetReqVo;

    @Watch('form.IsNeedWeight')
    private setForm(): void {
      if (this.form.IsNeedWeight) {
        this.ckOverWeightPromotDisable = false;
      } else {
        this.form.CkOverWeightPromot = false;
        this.ckOverWeightPromotDisable = true;
      }
    }
    private autoCreateCarCodeDisable = false;
    private autoCreateCarCodeCheckboxShow = false;
    private isNeedWeightDisabled = false;
    private notCheckReScan = false;

    private tipVisible = false;

    //
    private checkText = "不校验重复扫描";
    private hasSpecialShapedSorting: boolean = false;
    private hasHKVoiceOption = false;
    private invalidCpCode = "";

    private weightChange(val) {
      console.log(val)
      if (!val) {
        this.tipVisible = true
      } else {
        if (obj_ScanForOutbound_GetOff && obj_ScanForOutbound_GetOff.sendNeedWeightFlag) {
          obj_ScanForOutbound_GetOff.sendNeedWeightFlag(true);
        }
      }
    }

    private weightChangeClose() {
      this.form.IsNeedWeight = true;
      this.tipVisible = false;
    }

    private confirmChangeWeight() {
      this.tipVisible = false
      if (obj_ScanForOutbound_GetOff && obj_ScanForOutbound_GetOff.sendNeedWeightFlag) {
        obj_ScanForOutbound_GetOff.sendNeedWeightFlag(false);
      }
    }

    get AutoCreateCarCode(){
      return ScanforOutBound_GetOffModule.autoCreateCarCode;
    }
    set AutoCreateCarCode(boolValue){
      ScanforOutBound_GetOffModule.setAutoCreateCarCode(boolValue);
    }

    private globalConfig: any = {};
    private loginData: any = {};
    private GetInOutFlag(inoutflag)
    {
      debugger;
       try {
        let _request = {
          devMac: this.globalConfig.LocalMac,
          devType: this.globalConfig.CurrentDeviceType.toString(),
          body: {
            inOutFlag: inoutflag.toString(),
            shareFlag: null,
            optFlag: null,
            createUserName: null,
            schemeId: null,
            uploadDispatchTime: null,
            delFlag: null,
            deviceId: null,
            deviceName: null,
            modifyUserCode: null,
            modifyUserName: null,
            modifyTime: null,
            isLatticeDelay: null,
            id: null,
            sendMsg: null,
            threeCodeCount: null,
            createUserCode: null,
            enableTime: null,
            isDelayDispatch: null,
            schemeNo: null,
            ServerTime: null,
            sendTime: null,
            createTime: null,
            sendStatus: null,
            opEndTime: null,
            opStartTime: null,
            status: null
          }
        }
        let _response = JSON.parse(getLatticeScheme(JSON.stringify(_request)));
        if (_response.respcode == "000") {
          return _response.data.inOutFlag.toString();
        } else {
          LogHelper.Error("GetInOutFlag失败:"+_response.respMessage);
          return inoutflag.toString();
        }
      } catch (error) {
        LogHelper.Error("GetInOutFlag异常:"+error.toString());
        return inoutflag.toString();
      }

    }
    private mounted(): void {
      console.log("需要称重ddd");
      if (typeof obj_ScanForOutbound_GetOff !== 'undefined') {
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('SetIsNeedWeight', (value) => {
          this.form.IsNeedWeight = value;
          console.log("需要称重" + value);
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('SetCkOverWeightPromotDisable', (value) => {
          this.ckOverWeightPromotVisiable = value;
        });
        obj_ScanForOutbound_GetOff.registerJavaScriptCallback('SetInvalidCpCode', (value) => {
          this.invalidCpCode = value;
        });

        debugger;
        try {
          if (obj_ScanForOutbound_GetOff.hasSpecialShapedSorting())
          {
            this.hasSpecialShapedSorting = true;
          }
          else
          {
            this.hasSpecialShapedSorting = false;
          }
          console.log("异常件集中分拣模式" + this.hasSpecialShapedSorting);
        }
        catch (e) {
          console.log("异常件集中分拣模式" + this.hasSpecialShapedSorting + e);
        }

      }
      if (typeof obj_GlobalData_Core !== "undefined") {
        this.globalConfig = SystemConfigModule.globalData;
        this.loginData = SystemConfigModule.loginData;
        const addType = SystemConfigModule.systemData?.ModeInfo?.ModeAdd_Type;
        this.hasHKVoiceOption = (addType == ModeAddType.None || BizUtil.isControlWeight(addType));
        this.form.IsNeedHKVoice = this.hasHKVoiceOption;
      }
      if (this.globalConfig.CurrentOrgType == "TRANSFER_CENTER") {
        //转运中心的情况下
        debugger;
        if (this.globalConfig.CurrentDeviceType == 6 ||
            this.globalConfig.CurrentDeviceType == 8 ||
            this.globalConfig.IsBackLine == "1"
            // || this.globalConfig.CurrentDeviceType == 1 //测试用，上线前应该去除
        ) {
          console.log("转运中心-【回包线->IsBackLine='1'】或者【快手+交叉带->6】或者是【DWS+交叉带->8】的一种");
          //如果是【回包线->IsBackLine="1"】或者【快手+交叉带->6】或者是【DWS+交叉带->8】
          this.autoCreateCarCodeCheckboxShow = true;//展示自动生成车签勾选框
          this.autoCreateCarCodeDisable = false;//打开自动生成车签
          this.AutoCreateCarCode = true;//勾选自动生成车签
          this.form.CarSignNum = this.GetAutoCreateCarCode(false);//获取车签号
          if (this.form.CarSignNum == "") {
            this.$nextTick(()=>{
              this.AutoCreateCarCode = false;//勾选自动生成车签取消
              ScanforOutBound_GetOffModule.setLockedCarSignNumShow(false);
            });
          }else{
            ScanforOutBound_GetOffModule.setLockedCarSignNumShow(true);
          }
        } else {
          console.log("转运中心-非【回包线->IsBackLine='1'】或者【快手+交叉带->6】或者是【DWS+交叉带->8】");
          debugger;
          // if(this.GetInOutFlag(this.globalConfig.InOutFlag) == "1"){//此处根据网关接口的返回值，来进行进出港的判断//InOutFlag 1进港2出港3进出港
          //   this.AutoCreateCarCode = false;//取消勾选自动生成车签
          //   this.autoCreateCarCodeDisable = true;//关闭自动生成车签
          //   console.log("转运中心-非【回包线->IsBackLine='1'】或者【快手+交叉带->6】或者是【DWS+交叉带->8】- 进港");
          // } else {
            console.log("转运中心-非【回包线->IsBackLine='1'】或者【快手+交叉带->6】或者是【DWS+交叉带->8】- 进出港类型不判断");
            this.AutoCreateCarCode = false;//取消勾选自动生成车签
            this.autoCreateCarCodeCheckboxShow = true;//展示自动生成车签勾选框
            this.autoCreateCarCodeDisable = false;//打开自动生成车签
          // }
        }

        //当前设备类型是5或者7时展示
        if (this.globalConfig.CurrentDeviceType == 5 || this.globalConfig.CurrentDeviceType == 7 && this.hasSpecialShapedSorting)
        {
          this.checkText = "异形件集中分拣模式";
          this.notCheckReScan = true;
        }

        // 客户端支持是否需要重量
        if ('NeedWeight' in this.globalConfig) {
          // 出港且不是（回包线+不需要重量）
          if (this.globalConfig.InOutFlag == "2" && !(this.globalConfig.IsBackLine == "1" && this.globalConfig.RequiredWeight == "0")) {
            // 排除狂扫
            if (this.globalConfig.CurrentDeviceType != 3) {
              this.isNeedWeightDisabled = this.globalConfig.NeedWeight == 1;
            }
          }
        }
      } else {
        //非转运中心的情况下
        if (this.globalConfig.CurrentDeviceType == 6 || this.globalConfig.CurrentDeviceType == 8)
        {
          this.notCheckReScan = true;
        }
        if(this.GetInOutFlag(this.globalConfig.InOutFlag) == "1"){//此处根据网关接口的返回值，来进行进出港的判断//InOutFlag 1进港2出港3进出港
          console.log("非转运中心-进港");
          this.autoCreateCarCodeCheckboxShow = true;//展示自动生成车签勾选框
          this.autoCreateCarCodeDisable = false;//打开自动生成车签
          this.AutoCreateCarCode = true;//勾选自动生成车签
          // this.form.AutoCreateCarCodeCheckBox = true;
          this.form.CarSignNum = this.GetAutoCreateCarCode(false);//获取车签号
          if (this.form.CarSignNum == "") {
            this.$nextTick(()=>{
              this.AutoCreateCarCode = false;//勾选自动生成车签取消
              // this.form.AutoCreateCarCodeCheckBox = false;
              ScanforOutBound_GetOffModule.setLockedCarSignNumShow(false);
            });
          }else{
            ScanforOutBound_GetOffModule.setLockedCarSignNumShow(true);
          }

        } else {
          console.log("非转运中心-除了出港的其他类型");
          this.autoCreateCarCodeCheckboxShow = true;//展示自动生成车签勾选框
          this.autoCreateCarCodeDisable = false;//关闭自动生成车签
          this.AutoCreateCarCode = false;//勾选自动生成车签
        }
      }

      setInterval(() => {
        if (dayjs().format('HH:mm:ss') == "00:01:00") {
          if (this.AutoCreateCarCode == true) {
            this.form.CarSignNum = this.GetAutoCreateCarCode(true);
            if (this.form.CarSignNum == "") {
              this.$nextTick(()=>{
                this.AutoCreateCarCode = false;//勾选自动生成车签取消
                ScanforOutBound_GetOffModule.setLockedCarSignNumShow(false);
              });
            }
          }
        }
      }, 1000); //第二天的0时01分00秒 检查是否是需要自动勾选自动生成车签

      if (this.globalConfig.IsBackLine == "1" && this.globalConfig.RequiredWeight == "0" ) {
        this.isNeedWeightDisabled = true;
        console.log("回包线+不需要重量，不需要称重");
      }
    }
    private AutoCreateCarCodeChange(checkValue)
    {
      debugger;
      if (checkValue) {
        this.form.CarSignNum = this.GetAutoCreateCarCode(true);
        if (this.form.CarSignNum == "") {
          this.$nextTick(()=>{
            this.AutoCreateCarCode = false;//勾选自动生成车签
            ScanforOutBound_GetOffModule.setLockedCarSignNumShow(false);
          });
        } else {
          ScanforOutBound_GetOffModule.setLockedCarSignNumShow(true);
        }

      } else
      {
        this.form.CarSignNum = "";
        ScanforOutBound_GetOffModule.setErrorMessage("");
        ScanforOutBound_GetOffModule.setLockedCarSignNumShow(false);
      }
    }
    // 创建车签主记录、查找车牌号、查找车签件数
    public AfterGetAutoCreateCarCode(scanAreaContent)
    {
      this.$nextTick(()=>{
        debugger;
        // if (!common.GlobalCommonConfig.isCrossBelt){
        this.CreateCarCodeMasterRecord(scanAreaContent);
        // }
        this.GetCarNumInfoByCQ(scanAreaContent);
        let strNumber = this.GetUnLoadNumber(scanAreaContent);
        // SetNumberInCar?.ExecuteAsync(strNumber);
        ScanforOutBound_GetOffModule.setNumberInCarValue(parseInt(strNumber.toString()))
      });

    }
    //创建车签主记录
    public CreateCarCodeMasterRecord(carCode)
    {
      try
      {
       let strReturn = "";
       let stReturn :any = {};
       let requestMain = {
         devMac : this.globalConfig.LocalMac,
         devType : this.globalConfig.CurrentDeviceType.toString(),
         body : {
           mac : this.globalConfig.LocalMacIPv4,
           aviType : 0,
           trace : 0,
           isFirstTransfer : 1,
           mty : "0140",
           opRecord : {
             auxOpCode : "NEW",
              containerNo : carCode,
              createOrgCode : this.loginData.orgCode,
              createTerminal : this.globalConfig.LocalIPv4,
              createTime : dayjs().valueOf(),
              createUserCode : this.loginData.userCode,
              createUserName : this.loginData.employeeName,
              desOrgCode : "",
              deviceType : this.globalConfig.CurrentDeviceType.toString(),
              expType : 10,
              expressContentCode : "PKG",
              feeAmt : "",
              feeFlag : 0,
              frequencyNo : "",
              waybillNo : carCode,
              ioType : "01",
              lineNo : "",
              modifyOrgCode : "",
              modifyTerminal : "",
              modifyTime : dayjs().valueOf(),
              modifyUserCode : "",
              modifyUserName : "",
              nextOrgCode : "",
              orgCode : this.loginData.orgCode,
              // (Clock.GetNow().ToUniversalTime().Ticks - 621355968000000000) / 10000
              uploadTime : dayjs().valueOf(),
              transportTypeCode : "",
              transferStatus : 0,
              previousOrgCode : "",
              remark : "10010001",
              sourceOrgCode : this.loginData.orgCode,
              weighWeight : "",
              pkgWidth : "",
              inputWeight : "",
              pkgLength : "",
              pkgHeight : "",
              volumeWeight : "",
              opCode : 170,
              pkgQty : 1,
              routeCode : "",
              inOutFlag : this.globalConfig.InOutFlag,
              cpNo: this.invalidCpCode,
              supplementCpFlag: this.invalidCpCode ? "1" : "",
              customData :{
                effectiveTypeCode : "",
                status : "",
                type : 0,
                line : "0",
                repairCode : "",
                pdaNo : "",
                needArrTruck : 0,
                extend1 : this.globalConfig.MonitorLoginStatus ? "1" : "0",
                extend2 : "0",
                optArea : ""
              },
            },
          },
        };
        if (this.invalidCpCode) {
          this.invalidCpCode = "";
        }
        debugger;
        stReturn = this.NewGetOff(requestMain);
        if (stReturn.respcode != "000" && stReturn.respcode != "101")
        {
          ScanforOutBound_GetOffModule.setErrorMessage(stReturn?.respMessage);
          return;
        }
      }
      catch (ex)
      {
        LogHelper.Error("车签主记录异常"+ex);
        ScanforOutBound_GetOffModule.setErrorMessage("车签主记录创建失败");
      }
    }

    public NewGetOff( stGetOffData, bIsPackageCode = false)
        {
          debugger;
            try
            {
                //处理一些数据
                if (stGetOffData.body.opRecord.opCode == 170)
                {
                    stGetOffData.body.opRecord.expType = 40;
                }
                else
                {
                    if (stGetOffData.body.opRecord.waybillNo != null && stGetOffData.body.opRecord.waybillNo.Length >= 3)
                    {
                        if (bIsPackageCode)
                        {
                            stGetOffData.body.opRecord.expType = 20;
                        }
                        else
                        {
                            stGetOffData.body.opRecord.expType = 10;
                        }
                    }
                }
                // // string jsonData = js.Serialize(stGetOffData);//序列化

                // // // LogHelper.WriteLog("【下车】客户端发送报文：" + jsonData);

                // // string strNum = GetLength(jsonData).ToString("00000000");
                // // string strSignName = Encrypt(strNum + jsonData);
                // // string strUrl = string.Format(PerformanceGetOffServerPath, strServerIpAndPort, strToken, strSignName);

                // // string strResult = HttpTransportBase.HttpPost(strUrl, jsonData);

                let result = JSON.parse(debusOnly(JSON.stringify(stGetOffData)));
                return result;

                // if (!strResult.Contains("respcode"))
                // {
                //     stReturn.respcode = "-1";
                //     stReturn.respMessage = strResult;
                // }

                // JObject jsData = (JObject)JsonConvert.DeserializeObject(strResult);
                // stReturn.respMessage = jsData["respMessage"].ToString();
                // stReturn.respcode = jsData["respcode"].ToString();

                // stReturn = js.Deserialize<Return_Common>(strResult);

                // // LogHelper.WriteLog("【下车】业务网关返回报文：" + strResult);
                // if (stReturn.respcode == "000")
                //     return strRetOK;
                // else
                //     return stReturn.respMessage;
            }
            catch (ex)
            {
                LogHelper.WriteLog("NewGetOff接口异常：" + ex);
                return {respcode:"",respMessage:"NewGetOff接口异常:"+ex};
                // if (stReturn.respcode == "000")
                // {
                //     return strRetOK;
                // }
                // else
                // {
                //     return stReturn.respcode;
                // }
            }
        }
        //查找车牌信息
    public GetCarNumInfoByCQ(carcode)
    {
      debugger;
       this.form.CarNumInfo = "";

            let carNumInfo = "";
            try
            {
                let jbody =
                {
                    viewType: "1",
                    queryValue: carcode,
                    queryType: "17"
                };
                let request =
                {
                    devMac : this.globalConfig.LocalMac,
                    devType : this.globalConfig.CurrentDeviceType.toString(),
                    body : jbody
                };
                var response =  JSON.parse(getCQInfoByCode(JSON.stringify(request)));
                if (response == null || response.respcode != "000" || response.data == null)
                {
                    LogHelper.WriteLog("车签查询失败, 错误信息:" + response?.respMessage + "，错误代码：" + response?.respcode + "警告");
                }

                let jresponse = response.data;
                if (jresponse == null || jresponse == undefined )
                {
                    return;
                }

                if (this.IsNullorEmptyorUndefined(jresponse.carNumber) && this.IsNullorEmptyorUndefined(jresponse.carNumberExtend))
                {
                    LogHelper.WriteLog("查询不到该车签对应的运营单，请创单后再进行过磅！");
                }
                else
                {
                    if (!this.IsNullorEmptyorUndefined(jresponse.carNumberExtend))
                    {
                        // SetCarNumInfo?.ExecuteAsync(jresponse.CarNumberExtend);
                        this.form.CarNumInfo = jresponse.carNumberExtend;
                        // tbx_CarNumInfo.Text = jresponse.Value<string>("carNumberExtend");
                    }
                    else
                    {
                        // SetCarNumInfo?.ExecuteAsync(jresponse.CarNumber);
                        this.form.CarNumInfo = jresponse.carNumber;
                        // tbx_CarNumInfo.Text = ;
                    }
                }
            }
            catch (ex)
            {
                LogHelper.WriteLog("根据车签查询车牌接口异常" + ex.toString());
            }

            return;
    }
    //获取应扫件数
    public GetUnLoadNumber(strCarCode){
      debugger;
      let strCount = "0";
            let strGetUnLoadNumber :any = {};
            strGetUnLoadNumber.devMac = this.globalConfig.LocalMac;
            strGetUnLoadNumber.devType = "0";
            let _body :any = {};
            strGetUnLoadNumber.body = _body;
            strGetUnLoadNumber.body.queryType = "15";
            strGetUnLoadNumber.body.queryValue = strCarCode;
            strGetUnLoadNumber.body.viewType = "1";
            strGetUnLoadNumber.body.extend1 = this.loginData.orgCode;
            strGetUnLoadNumber.body.extend2 = "";
            strGetUnLoadNumber.body.extend3 = "";

            let strReturn = JSON.parse(unLoadNum(JSON.stringify(strGetUnLoadNumber)));

            if (strReturn.respcode != "000")
            {
                LogHelper.WriteLog("调用获取车签件数接口失败" + JSON.stringify(strReturn));
            }
            else
            {
                strCount = strReturn.data.number;
            }

            return strCount;

    }
    //字符串为null、空、未定义判断
  private IsNullorEmptyorUndefined(data) {
    if (data == null || data == undefined || data == "") {
      return true;
    } else {
      return false;
    }
  }
    // private AutoCreateCarCodeButtonClick()
    // {
    //   this.form.CarSignNum = this.GetAutoCreateCarCode(true);
    // }
    private GetAutoCreateCarCode(showErrorMessage)
    {
      //条件1.先判断有没有自动生成的车签号，如果没有直接重新请求，
      //条件2.如果存在单号，就先判断请求的时间是否为空,如果为空就重新请求，
      //条件3.如果存在单号，请求时间不为空,判断请求的时间在当前时间减去十分钟的之前还是之后，如果之前会重新请求，
      //如果以上3个条件都不满足，就不重新请求
      //最后return存储起来的自动生成的车签
      debugger;
      if (
        ScanforOutBound_GetOffModule.carCodeOfAutoCreateCarCode == "" ||
        ScanforOutBound_GetOffModule.generationTimeOfAutoCreateCarCode == "" ||
        (dayjs(ScanforOutBound_GetOffModule.generationTimeOfAutoCreateCarCode) <
            dayjs().subtract(10, "minute"))
      ) {
        debugger;
        //此处重新请求逻辑
        let request = {
          devMac : this.globalConfig.LocalMac,
          devType : this.globalConfig.CurrentDeviceType.toString(),
          body:{
            waybillNo: "",
            inOutFlag: this.globalConfig.InOutFlag.toString(),
            backPackageLine: this.globalConfig.IsBackLine.toString(),
            deviceModeType: this.globalConfig.CurrentDeviceType.toString(),
            extend1: "",
            extend2: "",
            extend3: ""
          }
        };
        debugger;
        let response = JSON.parse(get171Container(JSON.stringify(request)));
        if (response.respcode == "000") {
          if (response.data.isOnLine != undefined && response.data.isOnLine != null && response.data.isOnLine == "0") {
            if (showErrorMessage) {
              ScanforOutBound_GetOffModule.setErrorMessage("当前系统离线，无法自动生成车签");
            }
            ScanforOutBound_GetOffModule.setAutoCreateCarCodeDataAndCode(null);
          } else if (response.data.switchStatus != undefined && response.data.switchStatus != null && response.data.switchStatus == "0"){
            if (showErrorMessage) {
              ScanforOutBound_GetOffModule.setErrorMessage("当前组织无自动生成车签权限，请人工录入车签");
            }
            ScanforOutBound_GetOffModule.setAutoCreateCarCodeDataAndCode(null);
          } else if (response.data.containerStatus != undefined && response.data.containerStatus != null && response.data.containerStatus == "0"){
            if (showErrorMessage) {
              ScanforOutBound_GetOffModule.setErrorMessage("当前车签状态未不生成车签，无法自动生成车签");
            }
            ScanforOutBound_GetOffModule.setAutoCreateCarCodeDataAndCode(null);
          } else {
            ScanforOutBound_GetOffModule.setErrorMessage("");
            ScanforOutBound_GetOffModule.setAutoCreateCarCodeDataAndCode({ carCode: response.data.waybillNo, dateStr: dayjs().toString() });
            console.log("[Info]" + "由于车签记录为空/车签记录时间为空/超过10分钟的条件满足,自动请求的车签号为:"+ScanforOutBound_GetOffModule.carCodeOfAutoCreateCarCode);
          }
        } else {
          debugger;
          ScanforOutBound_GetOffModule.setErrorMessage(response.respMessage);
          ScanforOutBound_GetOffModule.setAutoCreateCarCodeDataAndCode(null);
        }
        // 进行车签的判定
        if (ScanforOutBound_GetOffModule.carCodeOfAutoCreateCarCode != "") {
          if (this.GetCarContainerStatus(ScanforOutBound_GetOffModule.carCodeOfAutoCreateCarCode))
          {
            this.AfterGetAutoCreateCarCode(ScanforOutBound_GetOffModule.carCodeOfAutoCreateCarCode);
            // 通知C#车签变更
            if (obj_ScanForOutbound_GetOff && obj_ScanForOutbound_GetOff.onCarSignChangedFromJS) {
              obj_ScanForOutbound_GetOff.onCarSignChangedFromJS(ScanforOutBound_GetOffModule.carCodeOfAutoCreateCarCode);
            }
          }
        }
      } else {
        console.log("[Info]" + "未触发自动生成车签接口,上一次请求的时间是"+dayjs(ScanforOutBound_GetOffModule.generationTimeOfAutoCreateCarCode).format("YYYY-MM-DDHH:mm:ss") +",10分钟时间未到,原车签号为:"+ScanforOutBound_GetOffModule.carCodeOfAutoCreateCarCode);
      }
      return ScanforOutBound_GetOffModule.carCodeOfAutoCreateCarCode;
    }

    public GetCarContainerStatus(carCode){
      try {
        let status = "";
        let jbody = {
          queryValue: carCode,
          queryType: "32",
          viewType: "",
          extend1: "",
          extend2: "",
          extend3: ""
        };
        let request = {
          devMac : this.globalConfig.LocalMac,
          devType : this.globalConfig.CurrentDeviceType.toString(),
          body : jbody
        };
        var response =  JSON.parse(carContainerStatus(JSON.stringify(request)));
        if (response.respcode == "000"){
          let jresponse = response.data;
          if (jresponse.status != null){
            status = jresponse.status;
          }
        }
        if (status != "1"){
          ScanforOutBound_GetOffModule.setErrorMessage(response.resMsg);
          ScanforOutBound_GetOffModule.setAutoCreateCarCodeDataAndCode(null);
          return false;
        }
        return true;
      }
      catch ( ex){
        LogHelper.WriteLog("车签状态查询接口异常" + ex.toString());
        ScanforOutBound_GetOffModule.setAutoCreateCarCodeDataAndCode(null);
        ScanforOutBound_GetOffModule.setErrorMessage("车签状态查询接口异常");
        return false;
      }
    }

    //获取异形件分拣格口，并发送至底层
    private  GetSpecialShapeSortingLatticeNo()
    {
      try{
        //如果当前组织不允许异形件分拣，则直接返回
        if (!this.hasSpecialShapedSorting)
        {
          return;
        }
        else
        {
          if (this.globalConfig.CurrentDeviceType == 5 ||
            this.globalConfig.CurrentDeviceType == 7)
          {
            if (this.form.NotCheckReScan)
            {
              debugger;
              obj_ScanForOutbound_GetOff.setSpecialSharpedLitticeNoToYtoserver(true);
            }
            else
            {
              obj_ScanForOutbound_GetOff.setSpecialSharpedLitticeNoToYtoserver(false);
            }
          }
        }
      }catch (e) {
        console.log("GetSpecialShapeSortingLatticeNo error" + e);
      }
    }

    private ckOverWeightPromotVisiable = false;
    private ckOverWeightPromotDisable = false;
  }
